/**
 * Revoked-integrations banner handlers (TV1-2446 slice 7)
 */

import type { CommandHandlerMap } from '@commandDrivenStateEngine/core/types';
import type { RevokedIntegrationsBannerState } from './revokedIntegrationsBanner.state';
import type { RevokedIntegrationsBannerCommand } from './revokedIntegrationsBanner.commands';

export const handlers: CommandHandlerMap<RevokedIntegrationsBannerState, RevokedIntegrationsBannerCommand> = {
  'integrations/revokedBanner/setAll': ( state, cmd ) => ({
    ...state,
    entries: cmd.payload.entries
  })
};
